import type { ReactNode } from 'react'

interface MetricCardProps {
  label: string
  value: ReactNode
  isLoading?: boolean
  icon?: ReactNode
  subtitle?: string
  className?: string
}

export default function MetricCard({ label, value, isLoading, icon, subtitle, className }: MetricCardProps) {
  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className || ''}`}>
      <div className="flex items-center justify-between mb-1">
        <div className="text-sm text-muted-foreground">{label}</div>
        {icon && <div className="text-muted-foreground">{icon}</div>}
      </div>
      <div className="text-2xl font-bold">
        {isLoading ? <span className="spinner h-6 w-6" /> : value}
      </div>
      {subtitle && <div className="text-xs text-muted-foreground mt-1">{subtitle}</div>}
    </div>
  )
}
